'use strict';

goog.require('Ntry.block');

Blockly.Blocks['ebs2015_maze_move_step'] = {
    init: function() {
        this.setColour('#A751E3');
        this.appendDummyInput()
            .appendField('앞으로 한 칸 가기')
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/moveStep.png',
                    '*',
                    'endOrigin'
                )
            );
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.ebs2015_maze_move_step = function(sprite, script) {
    if (!script.isStart) {
        script.isStart = true;
        script.isAction = true;
        var callBack = function() {
            script.isAction = false;
        };
        Ntry.dispatchEvent('unitAction', Ntry.STATIC.WALK, callBack);
        return script;
    } else if (script.isAction) {
        return script;
    } else {
        delete script.isAction;
        delete script.isStart;
        return script.callReturn();
    }
};

Blockly.Blocks['ebs2015_maze_while_true_1'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage('/legacy_img/assets/ntry/block_inner/flag.png', 22, 22)
        );
        this.appendDummyInput()
            .appendField('에 도착할 때 까지 반복')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setPreviousStatement(true);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.ebs2015_maze_while_true_1 = function(entity, script) {
    return script.getStatement('STACK', script);
};

Blockly.Blocks['ebs2015_maze_repeat_until_1'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField('모든');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage('/legacy_img/assets/ntry/block_inner/treasure.png', 22, 22)
        );
        this.appendDummyInput()
            .appendField('찾을 때까지 반복')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.ebs2015_maze_repeat_until_1 = function(sprite, script) {
    return script.getStatement('STACK', script);
};

Blockly.Blocks['ebs2015_maze_if_wall'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField('만약 앞에');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage('/legacy_img/assets/ntry/block_inner/wall.png', 22, 22, 'conical')
        );
        this.appendDummyInput()
            .appendField('있다면')
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', 'endOrigin'));
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.ebs2015_maze_if_wall = function(entity, script) {
    if (script.isLooped) {
        delete script.isLooped;
        return script.callReturn();
    }
    var unitComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.UNIT);
    var gridComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.GRID);

    var grid = { x: gridComp.x, y: gridComp.y };
    Ntry.addVectorByDirection(grid, unitComp.direction, 1);

    var existEntities = Ntry.entityManager.find({
        type: Ntry.STATIC.GRID,
        x: grid.x,
        y: grid.y,
    });
    if (existEntities.length == 0) return script.getStatement('STACK', script);

    var fitEntities = Ntry.entityManager.find(
        {
            type: Ntry.STATIC.GRID,
            x: grid.x,
            y: grid.y,
        },
        {
            type: Ntry.STATIC.TILE,
            tileType: Ntry.STATIC.WALL,
        }
    );

    if (!script.getStatement('STACK', script)) return null;
    if (fitEntities.length == 0) {
        return script.callReturn();
    } else {
        script.isLooped = true;
        return script.getStatement('STACK', script);
    }
};

Blockly.Blocks['ebs2015_maze_if_else_wall'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField('만약 앞에');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage('/legacy_img/assets/ntry/block_inner/wall.png', 22, 22, 'meteo')
        );
        this.appendDummyInput()
            .appendField('가 있다면')
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', 'endOrigin'));
        this.appendStatementInput('STACK_IF');
        this.appendDummyInput().appendField('아니면');
        this.appendStatementInput('STACK_ELSE');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.ebs2015_maze_if_else_wall = function(entity, script) {
    if (script.isLooped) {
        delete script.isLooped;
        return script.callReturn();
    }
    var unitComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.UNIT);
    var gridComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.GRID);

    var grid = { x: gridComp.x, y: gridComp.y };
    Ntry.addVectorByDirection(grid, unitComp.direction, 1);

    var existEntities = Ntry.entityManager.find({
        type: Ntry.STATIC.GRID,
        x: grid.x,
        y: grid.y,
    });
    if (existEntities.length == 0) return script.getStatement('STACK_IF', script);

    var fitEntities = Ntry.entityManager.find(
        {
            type: Ntry.STATIC.GRID,
            x: grid.x,
            y: grid.y,
        },
        {
            type: Ntry.STATIC.TILE,
            tileType: Ntry.STATIC.WALL,
        }
    );

    script.isLooped = true;
    if (fitEntities.length != 0) return script.getStatement('STACK_IF', script);
    else return script.getStatement('STACK_ELSE', script);
};

Blockly.Blocks['ebs2015_maze_if_else_notice'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField('만약 앞에');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage('/legacy_img/assets/ntry/block_inner/notice.png', 22, 22, 'meteo')
        );
        this.appendDummyInput()
            .appendField('가 있다면')
            .appendField(new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', 'endOrigin'));
        this.appendStatementInput('STACK_IF');
        this.appendDummyInput().appendField('아니면');
        this.appendStatementInput('STACK_ELSE');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.ebs2015_maze_if_else_notice = function(entity, script) {
    if (script.isLooped) {
        delete script.isLooped;
        return script.callReturn();
    }
    var unitComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.UNIT);
    var gridComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.GRID);

    var grid = { x: gridComp.x, y: gridComp.y };
    Ntry.addVectorByDirection(grid, unitComp.direction, 1);

    var existEntities = Ntry.entityManager.find({
        type: Ntry.STATIC.GRID,
        x: grid.x,
        y: grid.y,
    });
    if (existEntities.length == 0) return script.getStatement('STACK_IF', script);

    var fitEntities = Ntry.entityManager.find(
        {
            type: Ntry.STATIC.GRID,
            x: grid.x,
            y: grid.y,
        },
        {
            type: Ntry.STATIC.TILE,
            tileType: Ntry.STATIC.OBSTACLE_NOTICE,
        }
    );

    script.isLooped = true;
    if (fitEntities.length != 0) return script.getStatement('STACK_IF', script);
    else return script.getStatement('STACK_ELSE', script);
};
